import React from 'react';

import { Loading } from 'uikit/loaders';

import VideosBrowse from '../components/videosBrowse';

import useVideosBrowse from '../hooks/useVideosBrowse';

export default ({
  browse,
  isLoading,
}) => {
  const {
    view,
    onLoadMore,
    onViewChanged,
  } = useVideosBrowse();

  // if (isLoading) return <Loading />;

  return (
    <VideosBrowse
      browse={browse.data}
      view={view}
      onButtonGroupChanged={onViewChanged}
      onLoadMore={onLoadMore}
      isLoading={isLoading}
    />
  );
};
